module.exports = __webpack_public_path__ + "assets/img/6c9407a63c66a6c9d35ef3ce9b24fae9.png";